import { subscriptionDetails as EnUsSubscriptionDetails } from '../en-us/subscriptionDetails';
import { AgResourceLanguage } from '../types';

export const subscriptionDetails: AgResourceLanguage['subscriptionDetails'] = {
  ...EnUsSubscriptionDetails,
  orderFields: {
    ...EnUsSubscriptionDetails.orderFields,
    subscriptionTextBtn: 'Ajouter un produit à l’abonnement',
    subscriptionSubtotal: 'Sous-total de l’abonnement',
    nextSubtotal: 'Sous-total des ajouts uniques',
    nextTextBtn: 'Ajouter un produit à la prochaine commande',
    subscriptionTitle: 'Produits d’abonnement',
    nextTitle: 'Ajouts uniques'
  },
  active: {
    ...EnUsSubscriptionDetails.active,
    exploreButton: 'Ajouter un produit',
    free: 'Gratuit',
    shippingAddress: 'Adresse de livraison',
    subscriptionButton: 'Ajouter des produits',
    orderTotal: 'Total de la commande :',
    nextOrderButton: 'Ajouter un produit à la prochaine commande',
    emtyTitle: 'Ajouts uniques :',
    qty: 'x',
    subscriptionProductsTitle: 'Produits d’abonnement',
    lastOrderDetails: 'Détails de la dernière commande',
    backButton: 'Retour à la liste',
    emptyText:
      'Parcourez la gamme complète des produits et accessoires AG1, exclusivement disponibles pour les membres.',
    emptyButton: 'Ajouter un produit à la prochaine commande',
    nextOrderLabel: 'Prochaine date de commande :',
    addOns: 'Ajouts uniques :',
    nextShipmentTitle: 'Prochaine commande'
  },
  reactivate: {
    ...EnUsSubscriptionDetails.reactivate,
    headline: 'Votre abonnement a été annulé et une confirmation a été envoyée à {{email}}.',
    title: 'Au cas où vous nous manqueriez...',
    subTitle:
      'Nous serions ravis de vous retrouver ! Saviez-vous que ces options facilitent la gestion de votre abonnement AG1, que ce soit pour sauter une expédition ou obtenir plus de valeur?',
    agzSubTitle:
      'Nous serions ravis de vous revoir ! Vous pouvez vous connecter et réactiver votre abonnement à tout moment en cliquant sur « Réactiver ».',
    reactivateOfferCard: {
      ...EnUsSubscriptionDetails.reactivate.reactivateOfferCard,
      delay: {
        heading: '« J’ai trop de stock. »',
        text: 'Besoin de temps pour rattraper le retard ? Retardez votre prochaine livraison de AG1.',
        btnText: 'Réactiver & Retarder'
      },
      skip: {
        heading: '« J’ai trop de stock. »',
        text: 'Besoin de temps pour rattraper le retard ? Sautez votre prochaine livraison de AG1.',
        btnText: 'Réactiver & Sauter'
      },
      switch: {
        heading: '« Mon budget est serré. »',
        textTwoPouches:
          'Passez à 2 sachets expédiés tous les 60 jours pour bénéficier de prix réservés aux membres avec moins de livraisons (une valeur de 18 {{symbolCurrency}}).',
        textThreePouches:
          'Passez à 3 sachets expédiés tous les 90 jours pour bénéficier de prix réservés aux membres et de la livraison gratuite — une valeur de 42 {{symbolCurrency}}.',
        btnText: 'Réactiver & Changer'
      },
      upgrade: {
        heading: "“Je n'aime pas le goût.”",
        text: 'En un clic, passez votre abonnement à notre formule améliorée avec plus de probiotiques, de nutriments et une nouvelle saveur tropicale.',
        learnMoreLinkText: 'Apprendre encore plus.',
        btnText: 'Réactiver et mettre à niveau'
      }
    }
  },
  reactivateConfirm: {
    ...EnUsSubscriptionDetails.reactivateConfirm,
    title: 'Confirme ton nouveau plan',
    tableHead: 'Tu seras facturé le:',
    tableSubHead: 'Vous avez débloqué une',
    tableSubHeadValue: 'valeur',
    tableSubHeadOn: 'pour',
    subTotal: 'Sous-total',
    shipping: 'Frais de port',
    free: 'GRATUIT',
    total: 'Total',
    confirmButton: 'Confirmer',
    cancelButton: 'Non merci',
    offer: {
      subtitleThreePouches:
        'Réactivez votre abonnement et profitez des prix réservés aux membres et de la livraison gratuite — une valeur de {{symbolCurrency}}42.',
      subtitleTwoPouches:
        'Réactivez votre abonnement et profitez des prix réservés aux membres avec moins d’expéditions — une valeur de {{symbolCurrency}}18.',
      promotionText: '{{pouches}} sachets et moins d’expéditions'
    },
    newPlan: {
      title: 'Votre nouveau plan AG1 :',
      titleSecondary: 'Votre AG1 sera expédié :',
      mainText: '{{pouches}} sachets expédiés tous les {{days}} jours',
      nextShipment: 'Prochaine expédition :'
    }
  },
  reactivateSuccess: {
    ...EnUsSubscriptionDetails.reactivateSuccess,
    title: 'Nous sommes ravis de vous retrouver !',
    subBtn: 'Voir mon abonnement',
    learnMore: {
      title: 'Une nutrition de base en une seule dose',
      text: 'Chaque dose d’AG1 contient les bienfaits pour la santé de tout le corps dont vous avez besoin dans une simple habitude quotidienne.*',
      btnText: 'En savoir plus'
    },
    offer: {
      skip: 'Nous avons réactivé votre adhésion et sauté votre prochaine expédition. Ensemble, prenons soin de notre santé.',
      delay:
        'Nous avons réactivé votre adhésion et reporté votre prochaine expédition. Ensemble, prenons soin de notre santé.',
      default: 'Nous avons réactivé votre adhésion. Ensemble, prenons soin de notre santé.'
    }
  },
  v2: {
    ...EnUsSubscriptionDetails.v2,
    active: {
      ...EnUsSubscriptionDetails.v2.active,
      nextOrderTitle: 'Prochaine commande',
      shippingFrequency: 'Fréquence d’expédition',
      item: 'Tous les'
    },
    editFrequency: {
      day: 'Jour'
    },
    orderItems: {
      subscriptionDescription: 'Abonnement',
      nextOrderOnlyDescription: 'Seulement pour cette commande',
      toBeAppliedAfterNextOrder: 'À appliquer après la prochaine commande'
    },
    reactivate: {
      success: 'Votre abonnement a été réactivé'
    }
  }
};
